module.exports = __webpack_public_path__ + "7fb83d5d01d2e4f8691b7f99d41e3a44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/svgQuarterMap/data/zhQuarterMap.svg
// module id = 158
// module chunks = 0